// extracted by mini-css-extract-plugin
export var closeButton = "_22-0";